import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment.development';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Locality } from '../entities/locality';

interface ApiResponse {
  status: string;
  data: Locality[];
}

@Injectable({
  providedIn: 'root'
})
export class LocalityService {

  constructor(private http: HttpClient) { }

  private apiServicesUrl = environment.cfgApiBaseUrl;
  private localitiesServiceUrl = this.apiServicesUrl + '/locality';

  getLocalities(): Observable<ApiResponse> {
    return this.http.get<ApiResponse>(this.localitiesServiceUrl)
    .pipe(
      catchError(this.handleError<ApiResponse>('getLocalities'))
    );
  }

  getVisibleLocalitiesByCity(city: number): Observable<ApiResponse> {
    return this.http.get<ApiResponse>(this.localitiesServiceUrl + '-by-city', { params: { c: city } })
    .pipe(
      catchError(this.handleError<ApiResponse>('getLocalities'))
    );
  }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
  
      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead
  
      // TODO: better job of transforming error for user consumption
      //this.log(`${operation} failed: ${error.message}`);
  
      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

}
